<template>
  <div>

    <!-- //FILTRO -->
    <div class="row" v-if="!list">
      <div class="col-md-12 text-right" style="flex-wrap: wrap; margin-bottom: 10px">
        <btn-rounded class="text-right" :label="'NOVO'" event="novo" :active-color="'success'" />
        <btn-rounded class="text-right" :label="filter ? 'LIMPAR' : 'FILTRO'" event="showFilter"
          :active-color="filter ? 'danger' : 'primary'" />


      </div>


      <div v-if="filter">
        <div class="row" style="padding: 20px" text-center>
          <div class="col-md-3">
            <fg-select :options="adminList" v-model="filterOptions.isAdmin" :selected="filterOptions.isAdmin"
              label="Tipo de Usuário" />
          </div>
          <div class="col-md-3">
            <fg-select :options="activeList" v-model="filterOptions.isActive" :selected="filterOptions.isActive"
              label="Status Usuário" />
          </div>

          <div class="col-md-3">
            <fg-input type="date" label="Data de criação Inicial" :max="filterOptions.intervalEnd"
              v-model="filterOptions.intervalStart" />
          </div>

          <div class="col-md-3">
            <fg-input type="date" label="Data de criação Final" :min="filterOptions.intervalStart"
              v-model="filterOptions.intervalEnd" />
          </div>

        </div>

        <div class="row" style="padding: 20px" text-center>
          <div class="col-md-6">
            <fg-input type="text" label="Busca" placeholder="Nome, Email..." v-model="filterOptions.term" />
          </div>
        </div>

        <div class="row" style="margin-bottom: 20px">
          <div class="col-md-12" style="flex-wrap: wrap;">
            <div class="text-right">
              <btn-rounded class="text-right" label="FILTRAR" event="activeFilter" active-color="success" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FILTRO// -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <component-table :title="table.title" :sub-title="table.subTitle" :data="list || vipList"
            :columns="table.columns" :headers="table.headers" :control="table.control" />
        </div>
      </div>
    </div>
<v-dialog />
  </div>
</template>

<script>
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import moment from 'moment';
const headers = ["Nome", "Email", "Telefone", "Data Cadastro"];
const tableColumns = [
  "Buyer.name",
  "Buyer.email",
  "Buyer.formattedPhone",
  {
    columnName: "createdAt",
    logic: function (data) {
      if (!data) return '';
      return moment.utc(data).utcOffset(-180).format('D/M/YYYY H:mm:ss');
    }
  },
];
const control = [{
  event: "deleteVip",
  class: "ti-trash btn btn-danger btn-sm",
}]


export default {
  components: {
    ComponentTable
  },

  props: {
    list: {
      type: Array,
      default: () => {
        return null;
      }
    }
  },

  computed: {
    ...mapState({
      vipList: ({ vip }) => vip.list
    }),
    ...mapGetters({
      sidebarFlag: 'sidebarFlag'
    })
  },

  methods: {
    ...mapActions(["getVipList", "deleteVip"]),

    setPage: function (page) {
      this.page = page;
    },

    cleanFilter() {
      for (let idx in this.filterOptions) {
        this.filterOptions[idx] = undefined;
      }
      this.initData();
    },

    initData() {
      if (!this.list) {
        return this.getVipList(this.filterOptions);
      }

      return Promise.resolve({})
    },

    removeVip(vip) {
      console.log(vip)
      this.$modal.show('dialog', {
        title: 'Remoção de VIP',
        text: `Deseja remover ${vip.Buyer.name} da lista VIP?`,
        buttons: [{
          title: 'Sim',
          handler: () => {

            this.deleteVip(vip.id)
              .then(() => {
                this.$notify({
                  group: "foo",
                  title: "Sucesso",
                  text: "Removido com sucesso",
                  position: "top center",
                  type: "success"
                });
                this.initData();
              })
              .catch(err => {
                this.$notify({
                  group: "foo",
                  title: "Erro",
                  text: err || "Erro ao remover",
                  position: "top center",
                  type: "error"
                });
              });

            this.$modal.hide('dialog')

          }

        },
        {
          title: 'Não', // Button title
          handler: () => {

            this.$modal.hide('dialog')
          } // Button click handler
        }

        ]
      });


    }
  },

  created() {
    this.cleanFilter();
    this.$on("novo", () => {
      this.$router.push("/admin/vip/criar");
    });

    this.$on("deleteVip", (item) => {
      this.removeVip(item);
    });

    this.$on("showFilter", () => {
      if (this.filter) this.cleanFilter();
      this.filter = !this.filter;
    });
    this.$on("activeFilter", () => {
      if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
        return this.$notify({
          group: "foo",
          title: "Busca invalida",
          text: "Minímo de 3 caracteres",
          position: "top center",
          type: "error",
        });
      }
      this.initData();
    });
  },

  data() {
    return {
      page: 1,
      table: {
        title: "VIP",
        subTitle: "Lista de VIP's cadastrados",
        headers: [...headers],
        columns: [...tableColumns],
        control: [...control]
      },
      filter: false,
      filterOptions: {
        isAdmin: undefined,
        isActive: undefined,
        term: undefined,
        intervalStart: undefined,
        intervalEnd: undefined,

      },
      adminList: [
        {
          value: true,
          name: "Admin"
        },
        {
          value: false,
          name: "não Admin"
        }
      ],
      activeList: [
        {
          value: true,
          name: "Ativo"
        },
        {
          value: false,
          name: "Não Ativo"
        }
      ],

    };
  },

};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Vip/VipList.vue